// extracted by mini-css-extract-plugin
export var content = "_4b-3";
export var list = "_4b-4";
export var settingsContent = "_4b-7";
export var settingsPanel = "_4b-8";
export var state = "_4b-6";
export var triggerBadge = "_4b-2";
export var triggerButton = "_4b-1";
export var triggerShell = "_4b-0";
export var unreadDot = "_4b-5";